export const getReferenceCheckCounts = (
  referenceChecks:
    | {
        case: 'REQUESTED';
      }
    | {
        case: 'NOT_REQUESTED';
      }
    | {
        case: 'LIMITED_AVAILABLE' | 'STANDARD_AVAILABLE';
        counts: {
          finishedCount: number;
          totalCount: number;
        };
      },
) => {
  const isReferencesAvailable =
    referenceChecks.case === 'LIMITED_AVAILABLE' ||
    referenceChecks.case === 'STANDARD_AVAILABLE';
  return isReferencesAvailable ? referenceChecks.counts : undefined;
};
